'use client'

import styles from './EnterAnimation.module.sass'
import Image from "next/image";
import {useEffect, useRef, useState} from "react";
import gsap, {SteppedEase} from 'gsap'
import {useGSAP} from '@gsap/react'

import cn from "classnames";
import {useGameContext} from "@/context/GameContext";

const EnterAnimation = () => {

	const [firstLoad, setFirstLoad] = useState(true)
	const enterAnimationRef = useRef()

	const {setPlayHeroAnimation, isMobile} = useGameContext()

	const audio_cartridge = '/sound/cartridge.mp3'
	const audio_gameboy = '/sound/gameboy_startup.mp3'

	const loadAudios = () => {
		if(isMobile) return
		//Get by class audio
		window.audios = window.audios || {}

		if(!window.audios[audio_cartridge] && !isMobile) {
			window.audios[audio_cartridge] = new Audio(audio_cartridge);
			window.audios[audio_cartridge].volume = 1;
		}

		if(!window.audios[audio_gameboy] && !isMobile) {
			window.audios[audio_gameboy] = new Audio(audio_gameboy);
			window.audios[audio_gameboy].volume = 1;
		}
	}

	// useDebug({id: 'GSDevTools', animation: 'enter_animation', inTime: 0, outTime: 0, timeScale: 1})
	useEffect(() => {
		isMobile !== undefined && !isMobile && loadAudios()
	}, [isMobile]);

	useGSAP(() => {
		document.body.classList.add('no_scroll')

		// Create a cookie with a lifetime of 3 minute
		if (document.cookie.indexOf('firstLoad') === -1) {
			document.cookie = 'firstLoad=false;max-age=180'
		} else {
			setPlayHeroAnimation(true)
			setFirstLoad(false)
			return
		}

		//Get the isMobile
		const isMobile = window.innerWidth < 1025
		!isMobile && loadAudios()

		// Create a timeline
		const timeline = gsap.timeline({
			defaults: {
				duration: 1,
				ease:     'none',
			},
			id:       'enter_animation',
		})

		// Bring the 2 cartridge and the Game boy in the screen
		// Transform instead of top: moving with top shifts the layout on every frame (CLS)
		const travel = enterAnimationRef.current.offsetHeight
		timeline.to('.cartridge_container', {
			y: travel,
			duration: 1,
		})
		timeline.to('.gameboy_container', {
			y: -travel,
			duration: 1,
		}, '<').to({}, {
			onStart:() => {!isMobile && window.audios[audio_cartridge].play()},
			onComplete:() => {!isMobile && window.audios[audio_cartridge].pause()},
			duration: 1.5,
		}, '<')
		// Add the lights with the label
		timeline.addLabel('lightsLabel')
		.to('.red_dot', {
			opacity: 1,
			duration: .3,
		}, 'lightsLabel').to('.outerglow', {
			opacity: 1,
			duration: .3,
		}, 'lightsLabel+.2')
		.set('.glow', {
			opacity: 1,
		})
		.call(() => {
			gsap.to('.glow__gif', {
				repeat: 7,
				duration: .5,
				transform: `translateX(-30px)`,
				ease: SteppedEase.config(2),
			})
		})
		.to('.black_screen', {
			opacity: 0,
			duration: 1,
		}, 'lightsLabel').to('.screen', {
			opacity: 1,
			duration: 1,
		}, 'lightsLabel')
				.addLabel('gameLoadLabel')
				.to('.game_screen', {
			opacity: 1,
			duration: 1,
		}, 'gameLoadLabel')
				.to({}, {
					onStart:() => {!isMobile && window.audios[audio_gameboy].play()},
					onComplete:() => {!isMobile && window.audios[audio_gameboy].pause()},
					duration: 1.5,
				}, 'gameLoadLabel')
				// End Label
				.addLabel('endLabel')
				.to(enterAnimationRef.current, {
					opacity: 0,
					duration: 1
				}, 'endLabel')
				.call(() => {
					setPlayHeroAnimation(true)
					setFirstLoad(false)
				})
	}, {
		scope: enterAnimationRef,
		revertOnUpdate: true,
	});

	return (<div className={cn(styles.enter_animation, 'enter_animation', {[styles.ended]: !firstLoad})} ref={enterAnimationRef} data-lenis-prevent>
				<div  className={cn(styles.cartridge__container, 'cartridge_container')}>
					<Image src={"/images/EnterAnimation/cartridge.png"}
					       alt={"Gameboy cartridge"}
					       className={cn(styles.cartridge, 'cartridge')}
					       width={512}
					       height={512}
					       priority
					/>
				</div>
				<div className={cn(styles.gameboy__container, 'gameboy_container')}>
					<Image src={"/images/EnterAnimation/gameboy.png"}
					       alt={"Gameboy Image"}
					       className={cn(styles.gameboy, 'gameboy')}
					       width={512}
					       height={844}
					       priority/>
					{/*Screen*/}
					<div className={cn(styles.black_screen, 'black_screen')}></div>
					<div className={cn(styles.screen, 'screen')}></div>
					<Image src={"/images/EnterAnimation/game_screen.png"} alt={"Game screen"} className={cn(styles.game_screen, 'game_screen')} width={512} height={512}/>

					{/*Game boy Lights*/}
					<div className={styles.lights}>
						<Image src={"/images/EnterAnimation/gameboy_red_dot.png"}
						       alt={"Gameboy red dot"}
						       className={cn(styles.red_dot, 'red_dot')}
						       width={14}
						       height={14}/>
						<Image src={"/images/EnterAnimation/gameboy_outerglow.png"}
						       alt={"Gameboy outerline"}
						       className={cn(styles.outerglow, 'outerglow')}
						       width={20}
						       height={20}
						/>
						<div className={cn(styles.glow, 'glow')}>
							<Image className={cn(styles.glow__gif, 'glow__gif')} src={'/images/EnterAnimation/gameboy_glow_gif.png'} alt={"Gameboy glow gif"} width={12} height={12} unoptimized={true}/>
						</div>
					</div>
				</div>
			</div>
	)
}
export default EnterAnimation
